// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".favorite-label[data-v-73bb741e] {\n  margin: auto 0;\n  font-size: 13px;\n  font-weight: bold;\n}\n", ""]);
// Exports
module.exports = exports;
